import Vue from 'vue';
import axios from '@/plugins/axios.js';
import router from '@/router/index.js';
import i18n from '@/plugins/vue-i18n.js';

export default {
    async fetchAuthUser({ dispatch }, email) {
        const response = await axios.get('/auth-user', {
            params: {
                email,
            },
        });

        await dispatch('initializeState', response.data.data);

        return response.data.data;
    },

    clearAuthUser({ commit }) {
        commit('resetState');

        sessionStorage.setItem('authUser', JSON.stringify({}));

        axios.post('/logout');

        Vue.nextTick(() => {
            router.push({ name: 'auth.login' });
        });
    },

    async initializeState({ commit }, user) {
        commit('setAuthUser', user);
        commit('addClient', user.client);

        i18n.locale = user.locale;

        sessionStorage.setItem('authUser', JSON.stringify(user));

        try {
            const response = await axios.get('licenses/count-per-type');

            commit('setLicenseTypes', response.data);
        } catch (error) {
            console.log(error);
        }
    },

    async getOrders({ commit, rootState }, payload) {
        payload.client_id = rootState.authUser.client.id;

        const response = await axios.get('orders', { params: payload });

        commit('setOrders', response.data.data);

        return response.data;
    },

    async getOrder({ commit, rootState }, payload) {
        payload.client_id = rootState.authUser.client.id;

        const response = await axios.get('orders', { params: payload });

        commit('setOrders', response.data.data);

        return response.data;
    },
};
